// ==============================================================================
// 1. PRODUCT PAGE LOGIC: Heart Icon Toggle 
// ==============================================================================

document.addEventListener('DOMContentLoaded', function() {
  // Initial State Check for the Product Page Button
  const btn = document.querySelector('.wishlist-toggle-icon');
  if (btn) {
    const config = window.ShopifyWishlist;
    const productId = btn.getAttribute('data-product-id');
    
    // Checks if the global wishlist array (if you populate it) includes this ID
    const isSaved = window.userWishlistItems && window.userWishlistItems.includes(productId);
    
    if (isSaved) {
      btn.classList.add('is-saved');
    }
  }
});

// The Click Handler for the Heart Toggle
window.handleWishlistClick = async function(event) {
  const btn = event.currentTarget; 
  const config = window.ShopifyWishlist;
  const productId = btn.getAttribute('data-product-id');

  if (!config || !config.customerId) {
    alert('Please log in to save items to your wishlist.');
    return;
  }

  // Prevent spam clicking while fetching
  btn.style.pointerEvents = 'none';

  // Check current state based on the CSS class
  const isCurrentlySaved = btn.classList.contains('is-saved');
  const endpoint = isCurrentlySaved ? '/remove' : '/add';

  try {
    const response = await fetch(`${config.backendUrl}${endpoint}`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        customerId: config.customerId,
        productId: productId
      })
    });

    if (response.ok) {
      // Toggle the visual state via CSS class
      if (isCurrentlySaved) {
        btn.classList.remove('is-saved');
      } else {
        btn.classList.add('is-saved');
      }
    } else {
      throw new Error('Server Error');
    }
  } catch (error) {
    console.error('Wishlist Action Failed:', error);
    alert('Something went wrong. Please try again.');
  } finally {
    // Re-enable the button
    btn.style.pointerEvents = 'auto';
  }
};


// ==============================================================================
// 2. ACCOUNT PAGE LOGIC: Grid Hydration & Removal
// ==============================================================================

async function loadAccountWishlist() {
  const grid = document.getElementById('wishlist-grid');
  
  // If we aren't on the account page or don't have the config, stop.
  if (!grid || !window.ShopifyWishlist || !window.ShopifyWishlist.customerId) return;

  try {
    const response = await fetch(`${window.ShopifyWishlist.backendUrl}/get?customerId=${window.ShopifyWishlist.customerId}`);
    const data = await response.json();

    if (data.success && data.wishlist.length > 0) {
      grid.innerHTML = ''; // Clear loading text

      for (const item of data.wishlist) {
        try {
          // Use the suggest endpoint to find the product by numeric ID
          const prodResp = await fetch(`/search/suggest.json?q=id:${item.product_id}&resources[type]=product`);
          const searchData = await prodResp.json();
          
          // Dig into the resources object to find our product
          const product = searchData.resources.results.products[0];
          
          if (!product) {
            console.warn(`Product ID ${item.product_id} not found in search.`);
            continue; // Skip to the next item
          }

          const productHtml = `
            <div class="col-6 col-md-4 col-lg-3 tt-col-item">
              <div class="tt-product">
                <div class="tt-image-box">
                  <a href="${product.url}">
                    <img src="${product.image}" alt="${product.title}" style="max-width: 100%;">
                  </a>
                </div>
                <div class="tt-description">
                  <h2 class="tt-title" style="font-size: 12px; margin-top: 10px;">
                    <a href="${product.url}">${product.title}</a>
                  </h2>
                  <div class="tt-price" style="font-weight: bold; margin-top: 5px;">${product.price}</div>
                  
                  <button class="wishlist-account-remove" 
                          data-product-id="${item.product_id}" 
                          style="margin-top: 8px; font-size: 11px; text-decoration: underline; background: none; border: none; padding: 0; cursor: pointer; color: #999; text-transform: uppercase;">
                    Remove
                  </button>
                  
                </div>
              </div>
            </div>`;
          grid.insertAdjacentHTML('beforeend', productHtml);
        } catch (e) { 
          console.error("Hydration failed for ID:", item.product_id, e); 
        }
      } // End of for loop
    } else {
      grid.innerHTML = '<p style="padding-left: 15px;">You haven\'t saved any items yet.</p>';
    }
  } catch (err) {
    grid.innerHTML = '<p style="padding-left: 15px;">Unable to load wishlist.</p>';
    console.error("Wishlist fetch error:", err);
  }
} // End of loadAccountWishlist function

// Trigger load on the account page
if (window.location.pathname.includes('/account')) {
  document.addEventListener('DOMContentLoaded', loadAccountWishlist);
}

// Handle 'Remove' clicks on the account page
document.addEventListener('click', async (e) => {
  if (!e.target.classList.contains('wishlist-account-remove')) return;
  
  const btn = e.target;
  const productId = btn.getAttribute('data-product-id');
  const card = btn.closest('.tt-col-item'); // Grab the whole product card wrapper
  const config = window.ShopifyWishlist;

  if (!config || !config.customerId) return;
  
  // Visual feedback
  btn.innerText = 'Removing...';
  btn.style.pointerEvents = 'none';
  
  try {
    const response = await fetch(`${config.backendUrl}/remove`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        customerId: config.customerId,
        productId: productId
      })
    });
    
    if (response.ok) {
      // Fade out and remove the card from the DOM
      card.style.transition = 'opacity 0.3s ease';
      card.style.opacity = '0';
      
      setTimeout(() => {
        card.remove();
        
        // If that was the last item, show the empty state message
        const grid = document.getElementById('wishlist-grid');
        if (grid && grid.querySelectorAll('.tt-col-item').length === 0) {
          grid.innerHTML = '<p style="padding-left: 15px;">You haven\'t saved any items yet.</p>';
        }
      }, 300);
    } else {
      throw new Error('Server rejected removal');
    }
  } catch (error) {
    console.error('Account remove error:', error);
    btn.innerText = 'ERROR - RETRY?';
    btn.style.pointerEvents = 'auto';
  }
});